import { render, staticRenderFns } from "./InputDetails.vue?vue&type=template&id=451daf83"
import script from "./InputDetails.vue?vue&type=script&lang=js"
export * from "./InputDetails.vue?vue&type=script&lang=js"
import style0 from "./InputDetails.vue?vue&type=style&index=0&id=451daf83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports